import { render, staticRenderFns } from "./PromotionDefine.vue?vue&type=template&id=18500664&scoped=true"
import script from "./PromotionDefine.vue?vue&type=script&lang=js"
export * from "./PromotionDefine.vue?vue&type=script&lang=js"
import style0 from "./PromotionDefine.vue?vue&type=style&index=0&id=18500664&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18500664",
  null
  
)

export default component.exports